import type { BusinessAddressRef } from '@seek/hirer-business-address';
import type { CheckoutComponentProps } from '@seek/hirer-ecommerce';
import type { PaymentMethodType } from '@seek/payments-widget';

import { saveTrackingData } from 'src/app/shared/dataAnalytics/storage';

export const onPostAdButtonClicked = async ({
  businessAddressRef,
  paymentMedium,
  paymentMethod,
  isSavedCreditCard,
}: {
  businessAddressRef?: React.RefObject<BusinessAddressRef>;
  paymentMethod?: PaymentMethodType;
  paymentMedium?: string;
  isSavedCreditCard?: boolean;
}): Promise<void> => {
  saveTrackingData({
    isPaidByStoredCreditCard:
      paymentMethod === 'CreditCard' && Boolean(isSavedCreditCard),
    paymentMediumSelected: paymentMedium || null,
  });

  if (!businessAddressRef) return;

  const validationResult =
    await businessAddressRef.current?.validateAllFields();

  if (validationResult) {
    throw new Error('Business address validation failed');
  }

  businessAddressRef.current?.submitForm();
};

export const onPaymentSucceeded = async () => {};

export const onReplaceSavedCard: CheckoutComponentProps['callbacks']['onReplaceSavedCard'] =
  () => saveTrackingData({ paymentMethod: 'CreditCard' });

export const onSaveCardOptionChanged: CheckoutComponentProps['callbacks']['onSaveCardOptionChanged'] =
  (shouldSave) => saveTrackingData({ isSaveCreditCardChecked: shouldSave });

export const onSavedCardLoaded: CheckoutComponentProps['callbacks']['onSavedCardLoaded'] =
  () => saveTrackingData({ paymentMethod: 'SavedCreditCard' });

export const handleCancelledPayment: CheckoutComponentProps['callbacks']['handleCancelledPayment'] =
  async () => {};

export const onPaymentOptionChanged =
  (
    onChanged: (selectedItem: PaymentMethodType) => void,
  ): CheckoutComponentProps['callbacks']['handlePaymentOptionChange'] =>
  (_selectedIndex, selectedItem) => {
    if (!selectedItem) {
      return;
    }

    const paymentMethod = selectedItem as PaymentMethodType;
    onChanged(paymentMethod);
    saveTrackingData({ paymentMethod });
  };
